import { GRADEANDLEXILELEVELS } from "@/constants/GradeAndLexileLevels";
import ContentLevel from "@/types/models/ContentLevel.interface";
import { LANG } from "@/constants/Language/Language";

/**
 * Finds the level that corresponds to a numeric grade value.
 **/

const getCurrentLevelByNumericGrade = (
  levels: ContentLevel[],
  numericGrade: number | null,
  language?: LANG,
) => {
  if (!numericGrade) return null;

  const grade = GRADEANDLEXILELEVELS[numericGrade];
  return levels.find((level) => {
    if (language) {
      return level.grade_band === grade?.value && level.language === language;
    }

    return level.grade_band === grade?.value;
  });
};

export default getCurrentLevelByNumericGrade;
